<div class="frame-in">
  <div class="items zone-7-frame">
    <svg class="road zone-7">
      <style>
        tspan { white-space:pre }
        .shp0 { fill: none;stroke: #ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width: 5;stroke-dasharray: 15,15 }
      </style>
      <g id="GAME UI">
        <g id="ZONE 3">
          <g id="ZONE 3">
            <g id="Group 103">
              <g id="ZONE 3">
                <g id="Track lines ZONE4 copy 2">
                  <path id="Shape 3963" class="shp0" d="M386.79 0.03C390.26 -0.68 384.1 35.6 397 56C397 56 411.41 126.8 375 141" />
                  <path id="Shape 3620" class="shp0" d="M337 161C247.76 191.38 210.08 124.56 210.08 124.56C210.08 124.56 75.26 14.5 25 134" />
                  <path id="Shape 3622" class="shp0" d="M4.24 177C4.24 177 -14.22 243.12 31 245C76.22 246.88 109.39 254.18 129 258" />
                  <path id="Shape 3623" class="shp0" d="M171 270C171 270 230.97 283.73 211.9 338.81C203.33 363.55 165.22 394.08 130 406C90.09 419.51 64.66 423.39 60 428" />
                  <path id="Shape 3624" class="shp0" d="M48 460C48 460 89.24 483.45 110 484C110 484 178.65 485.84 196 484" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <div class="country zone-7"></div>
    <div class="poi quiz quiz-1"></div>

    @for (zone of zones; track zone) {
      <div>
        <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}"></div>
      </div>
    }

    @for (zone of zones; track zone; let i = $index) {
      <div
        class="poi {{zone.class}}"
        [ngClass]="{active: zone.active, 'lock': zone.locked}"
        (mouseenter)="mouseEnter(zone)"
        (mouseleave)="mouseLeave(zone)"
        (click)="selectZone(zone)"
        >
        <span>{{ zone.locked ? '' : zone.number}}</span>
      </div>
    }

    <div class="poi quiz quiz-2" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 7, 'active': quizLevel === 7 && tick2Quiz}"></div>
  </div>
</div>

<img class="frame-title" src="assets/images/zones/5/title.png">

<audio id="introductionAudio" (ended)="playBgAudio()">
  <source src="assets/sounds/country.wav" type="audio/wav">
</audio>
<audio id="bgAudio" (ended)="playIntroductionAudio()">
  <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
</audio>

<div class="footer">
  <ul class="zone-menu">
    <li>
      @if (!haveAccess('2-1')) {
        <span class="lock"></span>
      }
      @if (haveAccess('2-1')) {
        <a class="menu-item" [routerLink]="[ '/game/zone5' ]" routerLinkActive="active">1</a>
      }
    </li>
    <li>
      @if (!haveAccess('2-2')) {
        <span class="lock"></span>
      }
      @if (haveAccess('2-2')) {
        <a class="menu-item" [routerLink]="[ '/game/zone6' ]" routerLinkActive="active">2</a>
      }
    </li>
    <li>
      @if (!haveAccess('2-3')) {
        <span class="lock"></span>
      }
      @if (haveAccess('2-3')) {
        <a class="menu-item" [routerLink]="[ '/game/zone7' ]" routerLinkActive="active">3</a>
      }
    </li>
  </ul>
  <img class="footer-bg" src="assets/images/zones/7/footer.png">
</div>

<audio id="continentHover">
  <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
  <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
